export default __webpack_public_path__ + "static/media/desiredJob.ddfe8629.svg";